<template>
    <button :class="btnClass" @click="navigateToUrl">
      <slot></slot>
    </button>
  </template>
  
  <script lang="ts" setup>
  import { onMounted, ref } from 'vue';

  const props = defineProps({
    btnClass: {
      type: String,
      required: true
    },
    envUrlKey: {
      type: String,
      required: true
    }
  });

  const targetUrl = ref('');

  onMounted(() => {
    // Set the URL after component is mounted to handle client-side hydration
    if (props.envUrlKey && process.env[props.envUrlKey]) {
      targetUrl.value = process.env[props.envUrlKey];
    } else {
      console.error(`Environment variable ${props.envUrlKey} not found`);
    }
  });
  
  const navigateToUrl = () => {
    // Directly check environment variable again as a fallback
    const url = targetUrl.value || (props.envUrlKey && process.env[props.envUrlKey]);
    
    if (url) {
      // Use more reliable window.open method that works with prerendered pages
      window.open(url, '_blank', 'noopener,noreferrer');
    } else {
      console.error(`URL for ${props.envUrlKey} not available`);
    }
  };
  </script>
  
